import { Checkbox as CXCheckbox } from '@sanlamcx/react-ui-next-checkbox';

export const Checkbox = CXCheckbox;
